import { Injectable } from '@angular/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class LocalPersonsDbTableDefinition extends DbTableDefinition {
  tableName = 'local_persons';
  tableStructure = `(id INTEGER PRIMARY KEY AUTOINCREMENT,
     label TEXT NOT NULL,
     name TEXT,
     lastname TEXT,
     fullname TEXT,
     email TEXT,
     primaryphonenumber TEXT,
     branchid BIGINT(20),
     branchlabel TEXT,
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(41, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);
  }
}
